import { render } from "./HomeB.vue?vue&type=template&id=690acff4"
import script from "./HomeB.vue?vue&type=script&lang=js"
export * from "./HomeB.vue?vue&type=script&lang=js"

import "./HomeB.vue?vue&type=style&index=0&id=690acff4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__